import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Skladom from "./pages/Skladom";
import Error from "./pages/Error";
import SharedLayout from "./pages/SharedLayout";
import ScrollToTop from "./components/ScrollToTop"; 
import { DataProvider } from "./pages/DataContext";
import { Suspense } from "react";

function Loading() {
  return <div></div>;
}

const App = () => {
  return (
    <BrowserRouter>
      <DataProvider>
      <ScrollToTop/>
      <Suspense fallback={<Loading />}>
        <Routes>
          <Route path="/" element={<SharedLayout />}>
            <Route index element={<Skladom />} />
            </Route>
          <Route path="*" element={<Error />} />
        </Routes></Suspense>
      </DataProvider>
    </BrowserRouter>
  );
};


export default App